// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__38Ldu","clinicsSelect":"TableHeading_clinicsSelect__1-PFw"};